var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('live-hedging-block',{attrs:{"has-border":true,"title-size":12,"override-title-size":true,"title-icon":'true',"title-icon-size":7,"title-margin-top":'4px'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }